export { default } from './svg/back-arrow-nav.svg';
